import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const PREFIX = 'ADV PTL';

@Injectable()
export class TemplatePageTitleStrategy extends TitleStrategy {
	constructor(private readonly _title: Title) {
		super();
	}

	override updateTitle(_routerState: RouterStateSnapshot) {
		const title = this.buildTitle(_routerState);

		this._title.setTitle(title ? `${PREFIX} | ${title}` : PREFIX);
	}
}
